const _ = "_disabled_1vkx2_15", e = {
  "help-button-root": "_help-button-root_1vkx2_1",
  disabled: _,
  "size-small": "_size-small_1vkx2_20",
  "size-large": "_size-large_1vkx2_25",
  "on-gray-background": "_on-gray-background_1vkx2_30"
};
export {
  e as default,
  _ as disabled
};
//# sourceMappingURL=index.es671.js.map
